/**
 * Compresses a string with deflate-raw and returns the result packed as base64 — the pair the
 * crashlog service is told to expect for a `sendCrashlog` log.
 *
 * This uses the browser's native CompressionStream API.
 * The output is compatible with Node.js zlib.inflateRaw() for decompression.
 */
export async function deflateRawToBase64(text: string): Promise<string> {
    const stream = new Blob([text]).stream().pipeThrough(new CompressionStream('deflate-raw'))
    const buffer = await new Response(stream).arrayBuffer()
    const bytes = new Uint8Array(buffer)

    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve((reader.result as string).split(',')[1] ?? '')
        reader.onerror = reject
        reader.readAsDataURL(new Blob([bytes]))
    })
}
